module.exports = __webpack_public_path__ + "static/media/rectangle-outline.b26108b4.png";